<template>
  <div class="w-full mt-2">
    <div class="flex">
      <EuiHeading :level="4" class="mb-0 mt-auto">{{ title }}</EuiHeading>
      <div class="ml-auto mr-2">
        <div v-if="error === true" class="w-8 ml-auto mr-2 p-1 log_result log_ko">KO</div>
        <div v-else-if="error === false"
             class="w-8 ml-auto mr-2 p-1 log_result log_ok">
          OK
        </div>
      </div>
    </div>

    <div
        class="text-right mr-2 ml-auto h-0 w-8 copy_button"
        v-if="copyable"
    >
      <EuiButton
          iconOnly
          @click="copyTraceInClipboard"
          variant="outlined"
          color="primary"
          title="Copier le contenu dans le presse papier"
      >
        <EuiIcon name="duplicate"/>
      </EuiButton>
    </div>
    <EuiTextarea
        :id="`trace-${id}`"
        class="w-full mt-2"
        :class="{'log_with_error' : error,'log_without_error': !error}"
        enabled
        :rows="rows"
        :value="message" />

  </div>

</template>


<script>
import store from '@/store';

export default {
  name: 'components.logs.traceArea',
  props: {
    id: {
      type: String,
    },
    title: {
      type: String,
      default: 'Trace complète',
    },
    message: {
      type: String,
      required: true,
    },
    rows: {
      type: Number,
      default: 5,
    },
    error: {
      type: Boolean,
      default: false,
    },
    copyable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    copyTraceInClipboard() {
      const copyText = document.querySelector(`#trace-${this.id}`);
      copyText.select();
      document.execCommand('copy');
      store.dispatch('application/pushAlert', { message: 'Contenu copié dans le presse papier', type: 'success' });
    },
  },
};
</script>
